module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_dress@2x-61b759f474e815350ee2bd32be8ea75c.webp";